import React, { Component } from "react";

import { FirebaseProducts, firebase } from "../../../../firebase";
import { firebaseLooper } from "../../../ui/misc";

import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import CircularProgress from "@material-ui/core/CircularProgress";

import ProductCard from "../../../ui/ProductCard";

import Search from "./Search/Search";

class Products extends Component {
  state = {
    isLoading: true,
    products: [],
    filteredProducts: [],
    currentPage: null,
    totalPages: null,
    currentProducts: [],
    openSnasti: false,
    openPrimanki: false,
    openCatushki: false,
    openUdilishea: false,
    openNajivki: false,
    openPrikormki: false,
    openPodsaki: false,
    openSumki: false,
    openOdejda: false,
    openSnareajenie: false,
    search: "",
    selected: "Новые"
  };

  componentDidMount() {
    FirebaseProducts.orderByChild("isInStore")
      .equalTo("Да")
      .once("value")
      .then(snapshot => {
        const products = firebaseLooper(snapshot);
        let promises = [];

        for (let key in products) {
          promises.push(
            new Promise((resolved, reject) => {
              firebase
                .storage()
                .ref("product")
                .child(products[key].image)
                .getDownloadURL()
                .then(url => {
                  products[key].url = url;
                  resolved();
                });
            })
          );
        }

        Promise.all(promises).then(() => {
          this.setState({
            products
          });
        });
      });

    setTimeout(() => {
      this.setState({
        isLoading: false
      });
    }, 1000);
    FirebaseProducts.orderByChild("isInStore")
      .equalTo("Да")
      .once("value")
      .then(snapshot => {
        const filteredProducts = firebaseLooper(snapshot);
        let promises = [];

        for (let key in filteredProducts) {
          promises.push(
            new Promise((resolved, reject) => {
              firebase
                .storage()
                .ref("product")
                .child(filteredProducts[key].image)
                .getDownloadURL()
                .then(url => {
                  filteredProducts[key].url = url;
                  resolved();
                });
            })
          );
        }

        Promise.all(promises).then(() => {
          this.setState({
            filteredProducts
          });
        });
      });

    setTimeout(() => {
      this.setState({
        isLoading: false
      });
    }, 1000);
  }

  handleClick = (key, value) => {
    console.log(value);
    if (key === "Удилища") {
      this.setState(state => ({
        openUdilishea: !state.openUdilishea
      }));
    }
    if (key === "Катушки") {
      this.setState(state => ({
        openCatushki: !state.openCatushki
      }));
    }
    if (key === "Снасти") {
      this.setState(state => ({
        openSnasti: !state.openSnasti
      }));
    }
    if (key === "Приманки") {
      this.setState(state => ({
        openPrimanki: !state.openPrimanki
      }));
    }
    if (key === "Наживки") {
      this.setState(state => ({
        openNajivki: !state.openNajivki
      }));
    }
    if (key === "Прикормки") {
      this.setState(state => ({
        openPrikormki: !state.openPrikormki
      }));
    }
    if (key === "Подсаки") {
      this.setState(state => ({
        openPodsaki: !state.openPodsaki
      }));
    }
    if (key === "Сумки") {
      this.setState(state => ({ openSumki: !state.openSumki }));
    }
    if (key === "Одежда") {
      this.setState(state => ({
        openOdejda: !state.openOdejda
      }));
    }
    if (key === "Снаряжение") {
      this.setState(state => ({ openSnareajenie: !state.openSnareajenie }));
    }
  };

  showFilteredProduct = (type = "Новые") => {
    this.setState({
      selected: type
    });
    const list = this.state.products.filter(product => {
      return product.type === type;
    });

    this.setState({
      filteredProducts: type === "Новые" ? this.state.products : list
    });
  };

  // onPageChanged = data => {
  //   const { products } = this.state;
  //   const { currentPage, totalPages, pageLimit } = data;

  //   const offset = (currentPage - 1) * pageLimit;
  //   const currentProducts = products.slice(offset, offset + pageLimit);

  //   this.setState({ currentPage, currentProducts, totalPages });
  // };

  showProducts = filteredProducts =>
    filteredProducts.map((product, i) => (
      <React.Fragment key={i}>
        {product.isInStore === "Да" ? (
          <ProductCard
            image={product.url}
            title={product.title}
            desc={product.desc}
            linkTo={product.id}
            price={product.price}
            key={product.id}
            isInStore={product.isInStore}
            brand={product.brand}
            addStyles={{
              marginRight: '10px'
            }}
          />
        ) : null}
      </React.Fragment>
    ));

  updateSearch = event => {
    const search = event.target.value;
    let filteredProducts = this.state.products.filter(product => {
      return product.title.toLowerCase().indexOf(search.toLowerCase()) !== -1;
    });
    this.setState({
      search: search.substr(0, 15),
      filteredProducts
    });
  };

  render() {
    const pad = {
      paddingLeft: "15px"
    };

    const pad0 = {
      paddingLeft: "0"
    };
    return (
      <React.Fragment>
        <div id="search">
          <Search
            products={this.state.products}
            search={this.state.search}
            onChange={this.updateSearch.bind(this)}
          />
        </div>

        <div id="sidebar">
          <List
            component="nav"
            subheader={
              <ListSubheader
                component="h2"
                style={{
                  fontSize: "20px",
                  fontFamily: "Roboto, sans-serif",
                  color: "#005f9c",
                  fontWeight: "500",
                  position: "inherit",
                  textAlign: "center"
                }}
              >
                Каталог
              </ListSubheader>
            }
            className="sidebar_wrapper"
          >
            <ListItem
              button
              className={this.state.selected === "Новые" ? "active" : ""}
              onClick={() => this.showFilteredProduct("Новые")}
            >
              <ListItemText inset primary="Новые" style={pad0} />
            </ListItem>

            {/* ===================================== */}
            {/* ================Удилища============== */}
            {/* ===================================== */}

            <ListItem button onClick={() => this.handleClick("Удилища")}>
              <ListItemText inset primary="Удилища" style={pad0} />
              {this.state.openUdilishea ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse
              in={this.state.openUdilishea}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Карповые")}
                  className={this.state.selected === "Карповые" ? "active" : ""}
                >
                  <ListItemText inset primary="Карповые" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse
              in={this.state.openUdilishea}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Фидерные")}
                  className={this.state.selected === "Фидерные" ? "active" : ""}
                >
                  <ListItemText inset primary="Фидерные" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse
              in={this.state.openUdilishea}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Телескопические")}
                  className={
                    this.state.selected === "Телескопические" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Телескопические" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse
              in={this.state.openUdilishea}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Спиннинговые")}
                  className={
                    this.state.selected === "Спиннинговые" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Спиннинговые" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse
              in={this.state.openUdilishea}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Болонские")}
                  className={
                    this.state.selected === "Болонские" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Болонские" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse
              in={this.state.openUdilishea}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Джокерные")}
                  className={
                    this.state.selected === "Джокерные" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Джокерные" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            {/* ===================================== */}
            {/* ================Удилища============== */}
            {/* ===================================== */}

            {/* ===================================== */}
            {/* ================Катушки============== */}
            {/* ===================================== */}
            <ListItem button onClick={() => this.handleClick("Катушки")}>
              <ListItemText inset primary="Катушки" style={pad0} />
              {this.state.openCatushki ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={this.state.openCatushki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Безинерционные")}
                  className={
                    this.state.selected === "Безинерционные" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Безинерционные" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openCatushki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("с Бейтранером")}
                  className={
                    this.state.selected === "с Бейтранером" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="с Бейтранером" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openCatushki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Иннерционные")}
                  className={
                    this.state.selected === "Иннерционные" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Иннерционные" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            {/* ===================================== */}
            {/* ================Катушки============== */}
            {/* ===================================== */}

            {/* ===================================== */}
            {/* ================Снасти=============== */}
            {/* ===================================== */}

            <ListItem button onClick={() => this.handleClick("Снасти")}>
              <ListItemText inset primary="Снасти" style={pad0} />
              {this.state.openSnasti ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Готовый монтаж")}
                  className={
                    this.state.selected === "Готовый монтаж" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Готовый монтаж" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Крючки")}
                  className={this.state.selected === "Крючки" ? "active" : ""}
                >
                  <ListItemText inset primary="Крючки" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Вертлюги")}
                  className={this.state.selected === "Вертлюги" ? "active" : ""}
                >
                  <ListItemText inset primary="Вертлюги" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Карабины")}
                  className={this.state.selected === "Карабины" ? "active" : ""}
                >
                  <ListItemText inset primary="Карабины" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Поплавки")}
                  className={this.state.selected === "Поплавки" ? "active" : ""}
                >
                  <ListItemText inset primary="Поплавки" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Резинки")}
                  className={this.state.selected === "Резинки" ? "active" : ""}
                >
                  <ListItemText inset primary="Резинки" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Грузы")}
                  className={this.state.selected === "Грузы" ? "active" : ""}
                >
                  <ListItemText inset primary="Грузы" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Кормушки")}
                  className={this.state.selected === "Кормушки" ? "active" : ""}
                >
                  <ListItemText inset primary="Кормушки" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Лески")}
                  className={this.state.selected === "Лески" ? "active" : ""}
                >
                  <ListItemText inset primary="Лески" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Отводы")}
                  className={this.state.selected === "Отводы" ? "active" : ""}
                >
                  <ListItemText inset primary="Отводы" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Сигнализаторы")}
                  className={
                    this.state.selected === "Сигнализаторы" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Сигнализаторы" style={pad} />
                </ListItem>
              </List>
            </Collapse>
            <Collapse in={this.state.openSnasti} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Свингеры")}
                  className={this.state.selected === "Свингеры" ? "active" : ""}
                >
                  <ListItemText inset primary="Свингеры" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            {/* ===================================== */}
            {/* ================Снасти=============== */}
            {/* ===================================== */}

            {/* ===================================== */}
            {/* ================Приманки============ */}
            {/* ===================================== */}

            <ListItem button onClick={() => this.handleClick("Приманки")}>
              <ListItemText inset primary="Приманки" style={pad0} />
              {this.state.openPrimanki ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={this.state.openPrimanki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Блёсна")}
                  className={this.state.selected === "Блёсна" ? "active" : ""}
                >
                  <ListItemText inset primary="Блёсна" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openPrimanki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Воблеры")}
                  className={this.state.selected === "Воблеры" ? "active" : ""}
                >
                  <ListItemText inset primary="Воблеры" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openPrimanki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Cиликоны")}
                  className={this.state.selected === "Cиликоны" ? "active" : ""}
                >
                  <ListItemText inset primary="Cиликоны" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openPrimanki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Вертушки")}
                  className={this.state.selected === "Вертушки" ? "active" : ""}
                >
                  <ListItemText inset primary="Вертушки" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            {/* ===================================== */}
            {/* ================Приманки============ */}
            {/* ===================================== */}

            {/* ===================================== */}
            {/* ================Наживки============ */}
            {/* ===================================== */}

            <ListItem button onClick={() => this.handleClick("Наживки")}>
              <ListItemText inset primary="Наживки" style={pad0} />
              {this.state.openNajivki ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={this.state.openNajivki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Черви")}
                  className={this.state.selected === "Черви" ? "active" : ""}
                >
                  <ListItemText inset primary="Черви" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openNajivki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Опарыши")}
                  className={this.state.selected === "Опарыши" ? "active" : ""}
                >
                  <ListItemText inset primary="Опарыши" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openNajivki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Мотыли")}
                  className={this.state.selected === "Мотыли" ? "active" : ""}
                >
                  <ListItemText inset primary="Мотыли" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openNajivki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Кукуруза")}
                  className={this.state.selected === "Кукуруза" ? "active" : ""}
                >
                  <ListItemText inset primary="Кукуруза" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openNajivki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Воздушное тесто")}
                  className={
                    this.state.selected === "Воздушное тесто" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Воздушное тесто" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openNajivki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Бойлы")}
                  className={this.state.selected === "Бойлы" ? "active" : ""}
                >
                  <ListItemText inset primary="Бойлы" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openNajivki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Мамалыга")}
                  className={this.state.selected === "Мамалыга" ? "active" : ""}
                >
                  <ListItemText inset primary="Мамалыга" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openNajivki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Пеллетс")}
                  className={this.state.selected === "Пеллетс" ? "active" : ""}
                  
                >
                  <ListItemText inset primary="Пеллетс" style={pad}/>
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openNajivki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Технопуф")}
                  className={this.state.selected === "Технопуф" ? "active" : ""}
                >
                  <ListItemText inset primary="Технопуф" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            {/* ===================================== */}
            {/* ================Наживки============ */}
            {/* ===================================== */}

            {/* ===================================== */}
            {/* ================Прикормки============ */}
            {/* ===================================== */}

            <ListItem button onClick={() => this.handleClick("Прикормки")}>
              <ListItemText inset primary="Прикормки" style={pad0} />
              {this.state.openPrikormki ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
              in={this.state.openPrikormki}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Макухи")}
                  className={this.state.selected === "Макухи" ? "active" : ""}
                >
                  <ListItemText inset primary="Макухи" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse
              in={this.state.openPrikormki}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Ароматизаторы")}
                  className={
                    this.state.selected === "Ароматизаторы" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Ароматизаторы" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse
              in={this.state.openPrikormki}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Пластелин")}
                  className={
                    this.state.selected === "Пластелин" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Пластелин" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse
              in={this.state.openPrikormki}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Клей Рыбаловный")}
                  className={
                    this.state.selected === "Клей Рыбаловный" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Клей Рыбаловный" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            {/* ===================================== */}
            {/* ================Прикормки============ */}
            {/* ===================================== */}

            {/* ===================================== */}
            {/* ================Подсаки============ */}
            {/* ===================================== */}

            <ListItem button onClick={() => this.handleClick("Подсаки")}>
              <ListItemText inset primary="Подсаки" style={pad0} />
              {this.state.openPodsaki ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={this.state.openPodsaki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Подсаки")}
                  className={this.state.selected === "Подсаки" ? "active" : ""}
                >
                  <ListItemText inset primary="Подсаки" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openPodsaki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Раколовки")}
                  className={
                    this.state.selected === "Раколовки" ? "active" : ""
                  }
                >
                  <ListItemText inset primary="Раколовки" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openPodsaki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Садки")}
                  className={this.state.selected === "Садки" ? "active" : ""}
                >
                  <ListItemText inset primary="Садки" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            {/* ===================================== */}
            {/* ================Подсаки============ */}
            {/* ===================================== */}

            {/* ===================================== */}
            {/* ================Сумки============ */}
            {/* ===================================== */}

            <ListItem button onClick={() => this.handleClick("Сумки")}>
              <ListItemText inset primary="Сумки" style={pad0} />
              {this.state.openSumki ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={this.state.openSumki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Сумки")}
                  className={this.state.selected === "Сумки" ? "active" : ""}
                >
                  <ListItemText inset primary="Сумки" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openSumki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Чехлы")}
                  className={this.state.selected === "Чехлы" ? "active" : ""}
                >
                  <ListItemText inset primary="Чехлы" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openSumki} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Рюкзаки")}
                  className={this.state.selected === "Рюкзаки" ? "active" : ""}
                >
                  <ListItemText inset primary="Рюкзаки" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            {/* ===================================== */}
            {/* ================Сумки============ */}
            {/* ===================================== */}

            {/* ===================================== */}
            {/* ================Сумки============ */}
            {/* ===================================== */}

            <ListItem button onClick={() => this.handleClick("Одежда")}>
              <ListItemText inset primary="Одежда" style={pad0} />
              {this.state.openOdejda ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={this.state.openOdejda} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Жилеты")}
                  className={this.state.selected === "Жилеты" ? "active" : ""}
                >
                  <ListItemText inset primary="Жилеты" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openOdejda} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Костюмы")}
                  className={this.state.selected === "Костюмы" ? "active" : ""}
                >
                  <ListItemText inset primary="Костюмы" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openOdejda} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Накидки от комаров")}
                  className={
                    this.state.selected === "Накидки от комаров" ? "active" : ""
                  }
                >
                  <ListItemText
                    inset
                    primary="Накидки от комаров"
                    style={pad}
                  />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openOdejda} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Плащи")}
                  className={this.state.selected === "Плащи" ? "active" : ""}
                >
                  <ListItemText inset primary="Плащи" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse in={this.state.openOdejda} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Шорты")}
                  className={this.state.selected === "Шорты" ? "active" : ""}
                >
                  <ListItemText inset primary="Шорты" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            {/* ===================================== */}
            {/* ================Одежда============ */}
            {/* ===================================== */}

            {/* ===================================== */}
            {/* ================Снаряжение============ */}
            {/* ===================================== */}

            <ListItem button onClick={() => this.handleClick("Снаряжение")}>
              <ListItemText inset primary="Снаряжение" style={pad0} />
              {this.state.openSnareajenie ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
              in={this.state.openSnareajenie}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Кресла")}
                  className={this.state.selected === "Кресла" ? "active" : ""}
                >
                  <ListItemText inset primary="Кресла" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse
              in={this.state.openSnareajenie}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Стулья")}
                  className={this.state.selected === "Стулья" ? "active" : ""}
                >
                  <ListItemText inset primary="Стулья" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse
              in={this.state.openSnareajenie}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Палатки")}
                  className={this.state.selected === "Палатки" ? "active" : ""}
                >
                  <ListItemText inset primary="Палатки" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            <Collapse
              in={this.state.openSnareajenie}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => this.showFilteredProduct("Разное")}
                  className={this.state.selected === "Разное" ? "active" : ""}
                >
                  <ListItemText inset primary="Разное" style={pad} />
                </ListItem>
              </List>
            </Collapse>

            {/* ===================================== */}
            {/* ================Снаряжение============ */}
            {/* ===================================== */}
          </List>
        </div>

        {this.state.isLoading ? (
          <div
            style={{
              flexBasis: " 85%",
              display: "flex",
              justifyContent: "center",
              margin: "0 10% 700px 0"
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <div className="products-wrapper">
            {/* <Pagination
              totalRecords={totalProducts}
              pageLimit={6}
              pageNeighbours={1}
              onPageChanged={this.onPageChanged}
            />  */}
            {this.showProducts(this.state.filteredProducts)}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default Products;
